import React from "react";
import 'bootstrap/dist/css/bootstrap.css';
import fontawesome from '@fortawesome/fontawesome'
import $ from 'jquery'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckSquare, faCoffee} from '@fortawesome/fontawesome-free-solid'
import {WebService} from "../module/WebService";
import {AppConfig} from "../AppConfig";
import Cookies from 'universal-cookie';
import LoadingImage from "../components/LoadingImage";
import axios from "axios";
import {globalSession} from "../module/Session";

fontawesome.library.add(faCheckSquare, faCoffee);


const cookies = new Cookies();

class Login extends React.Component{

    webService = new WebService();

    constructor(props) {
        super(props);
        this.props = props;

        if(globalSession.check())
            window.location = AppConfig.pages.admin.home;
    }

    render() {
        return(
            <div style={{width:"100%"}}>
                <div style={{width:400+"px",margin:"125px auto"}}>
                    <div className="card">
                        <article className="card-body">
                            <h4 className="card-title text-center mb-4 mt-1"><img alt="Teknorot" width={64} height={64} src="../img/teknorot_logo.png"/> <strong>Çağrı Takip Sistemi</strong></h4>
                            <hr/>
                                <p id={"errorMsg"} className="text-danger text-center"/>
                                <form>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"> <FontAwesomeIcon icon="key"/></span>
                                            </div>
                                            <input id="registryNo" name="" className="form-control" placeholder="Sicil No." type="text"/>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"> <i className="fa fa-lock"/> </span>
                                            </div>
                                            <input id="password" className="form-control" placeholder="******" type="password"/>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <button onClick={this.login.bind(this)} type="button" className="btn btn-primary btn-block"> Giriş Yap</button>
                                    </div>
                                    <p id="loadingImg" style={{display:"none"}}><LoadingImage/></p>
                                    {/*<p className="text-center"><a href="#" className="btn">Şifremi Unuttum</a></p>*/}
                                </form>
                        </article>
                    </div>
                </div>
            </div>
        )
    }

    success(data){
        if(data.hasOwnProperty("token") && data["token"]!=null){
            //$("#errorMsg").html(JSON.stringify(data));

            globalSession.setName(data["name"]);
            globalSession.setSurname(data["surname"]);
            globalSession.setToken(data["token"]);
/*
            cookies.set(AppConfig.cookie.name, data["name"], { path: '/' });
            cookies.set(AppConfig.cookie.surname, data["surname"], { path: '/' });
            cookies.set(AppConfig.cookie.token, data["token"], { path: '/' });
*/

            window.location = AppConfig.pages.admin.home;
        }
        else {
            $("#errorMsg").html("Kullanıcı adı veya şifre yanlış");
        }
        $("#loadingImg").css({display:"none"});
    }

    fail(status){
        $("#errorMsg").html("Kullanıcı adı veya şifre yanlış");
        $("#loadingImg").css({display:"none"});
    }

    login(){
        $("#loadingImg").css({display:"block"});
        let registryNo = $("#registryNo").val();
        let password = $("#password").val();
        //alert(registryNo+"\n"+password);

        const param = {registryNo:registryNo,password:password};
        axios.post(AppConfig.server + AppConfig.service.admin.login, param,globalSession.getAuthToken())
            .then((res) => {
                const data = res.data;
                if (data.success) {
                    this.success(data["data"]);
                } else
                    this.fail();
            })
            .catch(e => {
                this.fail();
            })
    }
}

export default Login;